import http from '@/plugins/http';
import reportError from '@/utils/reportError';
import myStudentsTransformer from '../../transformers/students/mystudents';

// When the request succeeds
const success = (response, successCallback) => {
  response = myStudentsTransformer.fetchCollection(response);
  successCallback(response);
};

const PAGE_SIZE = 400;

const fetchPages = (params, page = 1, previous = []) => http.get('v3/students/mine', { params: { ...params, page } })
  .then(({ data }) => {
    if (!Array.isArray(data)) {
      return page === 1 ? data : previous;
    }
    const students = previous.concat(data);
    return data.length === PAGE_SIZE ? fetchPages(params, page + 1, students) : students;
  });

export default (filters, successCallback, failedCallback) => {
  const params = {};
  if (filters.text) {
    params.text = filters.text;
  }

  if (filters.geopool) {
    params.geo_pool = filters.geopool;
  }
  params.active_only = true;
  params.customer_pool = true;
  params.limit = PAGE_SIZE;

  fetchPages(params)
    .then((students) => {
      success(students, successCallback);
    })
    .catch((error) => {
      reportError(error, 'error when trying to get student list');
      if (failedCallback) {
        failedCallback(error);
      }
    });
};
